var App = App || {};

App.JumpLinks = (function ($) {
    'use strict';

    var $lastJLBHeight = 0,
        origJLBPosition = 0;
    var placeholderString = "";

    function init() {
        var $jumpLinksBand = $(".page-masthead .component-jumplinks");
        if (!$jumpLinksBand.length) {
            $jumpLinksBand = $(".component-jumplinks");
        }

        if ($jumpLinksBand.length) {
            var jumpLinks = $jumpLinksBand.find(".jump-link");
            var prevSib = $jumpLinksBand.prev(),
                parentElem = $jumpLinksBand.parent();
            var $target;
            var targetOffsets = [],
                workingJumpLinks = [];

            applySeparators(jumpLinks);
            calculateZoom($jumpLinksBand);
            
            $(document).scroll(function () {
                calculateZoom($jumpLinksBand);

                if (prevSib.length) {
                    applyStickyBand($jumpLinksBand, prevSib, true);
                } else {
                    applyStickyBand($jumpLinksBand, parentElem, false);
                }

                $(document).ready(function () {
                    //get target obj and target position of each jumplink
                    jumpLinks.each(function () {
                        var hrefValue = $(this).children("a").attr("href");
                        if (hrefValue && hrefValue.indexOf('#') === 0) {
                            $target = $(hrefValue);
                            if ($target.length) {
                                workingJumpLinks.push($(this));
                                targetOffsets.push($target.offset().top);
                            }
                        }                       
                    });

                    applyScrollOffset($jumpLinksBand.outerHeight());
                });

                //underline jumplink when viewing the target area
                for (var i = 0; i < targetOffsets.length; i++) {
                    if ($(window).scrollTop() + ($jumpLinksBand.outerHeight() * 2) >= targetOffsets[i]) {
                        if (i == targetOffsets.length - 1) {
                            workingJumpLinks[i].addClass("active"); //keep last link underlined
                        }
                        else if ($(window).scrollTop() + ($jumpLinksBand.outerHeight() * 2) < targetOffsets[i + 1]) {
                            workingJumpLinks[i].addClass("active"); //underline current link
                        }
                        else {
                            workingJumpLinks[i].removeClass("active"); //no underlines if above all links
                        }
                    }
                    else {
                        workingJumpLinks[i].removeClass("active"); //remove underline from all other links
                    }
                }

            });

            $(window).resize(function () {
                var jumpLinks = $jumpLinksBand.find(".jump-link");
                applySeparators(jumpLinks);

                applyScrollOffset($jumpLinksBand.outerHeight());
            })
        };
    }

    function applyStickyBand($jumpLinksBand, placeholderElem, isPrevSib) {
        if (isPrevSib) {
            origJLBPosition = placeholderElem.offset().top + placeholderElem.outerHeight(true);
        }
        else {
            origJLBPosition = placeholderElem.offset().top;
        }
        if (!$jumpLinksBand.hasClass("sticky")) {
            if ($(window).scrollTop() > origJLBPosition) { //set jumplinks bar as sticky header when scrolled below original position
                if (!$("#jumplink-placeholder").length) {
                    placeholderString = generatePlaceholder($jumpLinksBand);
                    if (isPrevSib) {
                        placeholderElem.after(placeholderString);
                    }
                    else {
                        placeholderElem.prepend(placeholderString);
                    }
                }
                $jumpLinksBand.addClass("sticky");
                $("body").prepend($jumpLinksBand);
            }
        } else {
            if ($(window).scrollTop() <= origJLBPosition) { //remove placeholder and return band to original position when scrolled above original position
                $(".component-jumplinks.sticky").removeClass("sticky");
                if (isPrevSib) {
                    placeholderElem.after($jumpLinksBand);
                } else {
                    placeholderElem.prepend($jumpLinksBand);
                }
                $("#jumplink-placeholder").remove();
            }
        }
    }

    function calculateZoom($jumpLinksBand) {
        //remove sticky bar from screen when zoom would make it prohibitively large
        let zoom = ((window.outerWidth - 10) / window.innerWidth) * 100;
        if (zoom >= 250) {
            $jumpLinksBand.addClass("zoomed");
        } else {
            $jumpLinksBand.removeClass("zoomed");
        }
    }

    function generatePlaceholder($jumpLinksBand) {
        //placeholder occupies space off-screen to prevent page lurch
        return "<div id=\"jumplink-placeholder\" style=\"height:" + $jumpLinksBand.outerHeight() + "px; margin-top:" + $jumpLinksBand.css("margin-top") + "; margin-bottom:" + $jumpLinksBand.css("margin-bottom") + ";\"></div>";
    }

    function applySeparators(jumpLinks) {
        jumpLinks.removeClass("separated");
        if (jumpLinks.length) {
            var currentLineTop = 0,
                currentItemTop;
            jumpLinks.each(function () {
                currentItemTop = $(this).offset().top;
                if (currentItemTop == currentLineTop) {
                    $(this).addClass("separated"); //add separator only if this is not the first item on the line
                } else {
                    currentLineTop = currentItemTop;
                }
            });
        }
    }

    function applyScrollOffset(currentHeight) {
        //keep sticky bar height updated
        if ($lastJLBHeight != currentHeight) {
            $lastJLBHeight = currentHeight;
            $(".component, .component-group, .scroll-margin-top").css("scroll-margin-top", currentHeight);
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.JumpLinks.init();
});